import { useState } from 'react';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { Search } from '@mui/icons-material';
import { Typography, Box, TextField, CircularProgress, Autocomplete, IconButton } from '@mui/material';
import axios from '../../utils/axios';

QuickbooksSearchSelect.propTypes = {
  formValue: PropTypes.object,
  setFormValue: PropTypes.func,
  url: PropTypes.string,
}

export default function QuickbooksSearchSelect({ formValue, setFormValue, url }) {
  const { enqueueSnackbar } = useSnackbar();

  const [quickbooksSearch, setQuickbooksSearch] = useState("");
  const [searchingQuickbooks, setSearchingQuickbooks] = useState(false);
  const [quickbooksData, setQuickbooksData] = useState([]);


  const searchQuickbooks = () => {
    setSearchingQuickbooks(true);
    axios.get(`${url}?search=${quickbooksSearch}`)
      .then((res) => {
        setQuickbooksSearch("");
        setQuickbooksData((res.data ?? []).map(dataItem => ({ ...dataItem, label: `${dataItem.label} (${dataItem.value})` })));
      })
      .catch(() => enqueueSnackbar(`Quickbooks search failed`, { variant: 'error' }))
      .finally(() => setSearchingQuickbooks(false));
  };

  return <Box sx={{ width: "100%" }}>
    <Typography variant="subtitle1">Quickbooks Id</Typography>
    <Box display="flex">
      <Autocomplete
        fullWidth
        freeSolo
        size="small"
        value={quickbooksData.find(cust => cust.value === formValue.quickbooksId) ??
          (formValue.quickbooksId ? { value: formValue.quickbooksId, label: formValue.quickbooksId } : null)}
        onChange={(event, val) => setFormValue(form => ({ ...form, quickbooksId: val?.value }))}
        options={quickbooksData.some(cust => cust.value === formValue.quickbooksId) || !formValue.quickbooksId ? quickbooksData :
          [...quickbooksData, { value: formValue.quickbooksId, label: formValue.quickbooksId }]}
        renderInput={(params) => <TextField {...params} placeholder="Quickbooks Id" />}
        onInput={(e) => { setQuickbooksSearch(e.target.value); setFormValue(form => ({ ...form, quickbooksId: e.target.value })); }}
      />
      <IconButton onClick={searchQuickbooks}>
        {searchingQuickbooks ? <CircularProgress size={24} /> : <Search />}
      </IconButton>
    </Box>
  </Box>;
}
